import { Routes } from "@angular/router";

import { ChangePasswordComponent } from "./pages/change-password/change-password.component";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { LoginComponent } from "./pages/login/login.component";
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { SuccessComponent } from "./pages/success/success.component";

export const AUTH_ROUTES: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "change-password", component: ChangePasswordComponent },
  {
    path: "password/reset",
    component: ResetPasswordComponent,
  },

  {
    path: "password/reset/success",
    component: SuccessComponent,
  },
];
